module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"OK":"WebP対応","NG":"非対応"},"en":{"OK":"WebP OK","NG":"NG"}}')
  delete Component.options._Ctor
}
